import { useState } from 'react';
import { Button, IconButton, Grid, TextField, Typography } from '@material-ui/core';
import { useDispatch } from "react-redux";
import { postDeleteAccountReducer } from "../../../Redux/Reducers/OnboardingReducer";
import { useNavigate } from 'react-router-dom';
import { useQuantityContext } from '../../QuantityContext';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { VisibilityOff } from '@mui/icons-material';

const UserAccountDelete = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [password, setPassword] = useState('');
    const [errorMessage, seterrorMessage] = useState('');
    const { handleSuccess, handleInfo, toggleBtn, setToggleBtn } = useQuantityContext();
    const objectId = localStorage.getItem('objectId')?.trim();
    const apiKey = process.env.REACT_APP_API_KEY;
    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json'
    };
    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back to the previous page
        } else {
            navigate("/"); // Fallback to home page if no history exists
        }
    };
    const handleAccount = async () => {
        const payload = {
            "password": password
        }
        try {
            const response = await dispatch(postDeleteAccountReducer(payload));
            console.log("response from Delete Account", response.payload?.statusCode);

            if (response?.payload?.statusCode === 409) {

                // Call the userDetails API to set the details in localStorage
                const userResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`, {
                    headers: {
                        ...headers,
                        'Authorization': `Bearer ${objectId}`
                    }
                });
                const userData = userResponse?.data?.data?.user;
                localStorage.setItem("userDetails", JSON.stringify(userData));
                handleInfo("User has already requested for account deletion.");
                navigate("/home");
                return;
            }
            if (response?.payload?.statusCode === 201) {

                const userResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`, {
                    headers: {
                        ...headers,
                        'Authorization': `Bearer ${objectId}`
                    }
                });
                const userData = userResponse?.data?.data?.user;
                localStorage.setItem("userDetails", JSON.stringify(userData));

                handleSuccess("Account Deleted successfully.")
                navigate("/home");
                return;
            }
        } catch (error) {
            console.log("API ERROR", error);
        }
    }

    return (
        <div className="py-5 my-5 d-flex align-items-center justify-content-center">
            <div className='p-4 rounded bg-white d-flex flex-column' style={{ boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.5)", width: "600px" }}>
                <div>
                    <h6 className='mb-0' style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>
                        Are you sure you want to delete your Account?
                    </h6>
                </div>
                <Typography variant="body2" className="text-muted">This action cannot be undone. All information associated with this will be lost.</Typography>

                <div className='mt-3'>

                    <FormControl sx={{ m: 1, width: '50ch' }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type='password'
                            label="Password"
                            fullWidth
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>


                </div>

                {errorMessage && <Typography variant="body2" color="error">{errorMessage}</Typography>}

                <div>
                    <Button onClick={handleBack} className="mx-2 mt-2">
                        BACK
                    </Button>
                    <Button onClick={handleAccount} className="delete-button_configuration mt-2">
                        DELETE
                    </Button>
                </div>
            </div>
        </div>

    )
}

export default UserAccountDelete